export default "__VITE_ASSET__12000a88__"